import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79efe8e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid row gap-5 p-0" }
const _hoisted_2 = { class: "col-12 d-flex justify-content-between align-items-center p-0" }
const _hoisted_3 = { class: "d-flex gap-3" }
const _hoisted_4 = { class: "block" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-download text-red",
  style: {"font-size":"20px"}
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  style: {"height":"fit-content","width":"fit-content","font-size":"20px"},
  class: "m-0 fas fa-arrow-left"
}, null, -1))
const _hoisted_7 = { class: "p-0" }
const _hoisted_8 = { class: "row cards_principais" }
const _hoisted_9 = { class: "col-lg-6 col-md-12 col-sm-12 mb-0" }
const _hoisted_10 = { class: "card p-0 m-0" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h2", { class: "py-3 m-0" }, "Tipo Consulta")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex" })
], -1))
const _hoisted_12 = { class: "card-body pt-1" }
const _hoisted_13 = {
  class: "d-flex align-items-center gap-1 pb-2",
  style: {"height":"50px"}
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Total de consultas: ", -1))
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 1,
  class: "d-flex",
  style: {"min-width":"2rem"}
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 1,
  width: "220",
  height: "220",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  opacity: "0.3",
  d: "M19.4041 11.1765H10.6802L16.4902 16.9864C16.7122 17.2085 17.0777 17.2265 17.306 17.0114C18.7288 15.671 19.7074 13.864 19.9946 11.8327C20.0438 11.4849 19.7552 11.1765 19.4041 11.1765ZM18.8221 8.79412C18.5192 4.40221 15.0096 0.892649 10.6177 0.589708C10.2824 0.566547 10.0001 0.849267 10.0001 1.1853V9.41177H18.2269C18.5629 9.41177 18.8453 9.12941 18.8221 8.79412ZM8.23537 11.1765V2.45258C8.23537 2.10147 7.92692 1.81287 7.57949 1.86213C3.19824 2.48125 -0.150655 6.30883 0.00522741 10.896C0.165522 15.607 4.22177 19.4702 8.93501 19.411C10.7879 19.3879 12.5001 18.7908 13.9078 17.7923C14.1982 17.5864 14.2174 17.1588 13.9655 16.907L8.23537 11.1765Z",
  fill: "gray"
}, null, -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = {
  key: 1,
  class: "card p-4"
}
const _hoisted_22 = { class: "col-lg-6 col-md-12 col-sm-12 mb-0" }
const _hoisted_23 = { class: "card p-0 m-0" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "py-3 m-0" }, "Marcas")
], -1))
const _hoisted_25 = { class: "card-body pt-1" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex align-items-center gap-1 pb-2",
  style: {"height":"50px"}
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "d-flex",
    style: {"min-width":"2rem"}
  })
], -1))
const _hoisted_27 = {
  class: "d-flex justify-content-between align-itens-center gap-1 pb-2",
  style: {"height":"50px"}
}
const _hoisted_28 = { key: 0 }
const _hoisted_29 = {
  key: 1,
  width: "220",
  height: "220",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  opacity: "0.3",
  d: "M19.4041 11.1765H10.6802L16.4902 16.9864C16.7122 17.2085 17.0777 17.2265 17.306 17.0114C18.7288 15.671 19.7074 13.864 19.9946 11.8327C20.0438 11.4849 19.7552 11.1765 19.4041 11.1765ZM18.8221 8.79412C18.5192 4.40221 15.0096 0.892649 10.6177 0.589708C10.2824 0.566547 10.0001 0.849267 10.0001 1.1853V9.41177H18.2269C18.5629 9.41177 18.8453 9.12941 18.8221 8.79412ZM8.23537 11.1765V2.45258C8.23537 2.10147 7.92692 1.81287 7.57949 1.86213C3.19824 2.48125 -0.150655 6.30883 0.00522741 10.896C0.165522 15.607 4.22177 19.4702 8.93501 19.411C10.7879 19.3879 12.5001 18.7908 13.9078 17.7923C14.1982 17.5864 14.2174 17.1588 13.9655 16.907L8.23537 11.1765Z",
  fill: "gray"
}, null, -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = {
  key: 1,
  class: "card p-4"
}
const _hoisted_33 = {
  key: 0,
  class: "card tabela-container p-0"
}
const _hoisted_34 = {
  key: 0,
  class: "table table-striped"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "header-list" }, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bold rounded" }, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Marca"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Modelo"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Ano"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col d-flex align-items-center",
      style: {"text-align":"center !important"}
    }, "Data")
  ])
], -1))
const _hoisted_36 = { class: "d-flex justify-content-center" }
const _hoisted_37 = {
  key: 1,
  class: "header-list d-flex justify-content-center align-items-center p-4"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Nenhum resultado encontrado... ", -1))
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = {
  key: 1,
  class: "card p-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_config_provider = _resolveComponent("el-config-provider")!
  const _component_Button = _resolveComponent("Button")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_Title, null, {
        default: _withCtx(() => [
          _createTextVNode("Relatório de consultas - " + _toDisplayString(_ctx.nomeLoja), 1)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_config_provider, { locale: _ctx.ptBr }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.dataInput,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dataInput) = $event)),
                type: "month",
                placeholder: "Selecione o mês"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["locale"])
        ]),
        _createVNode(_component_Button, {
          text: "Download",
          onClick: _ctx.downloadProducts
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Button, {
          text: "Voltar",
          onClick: _cache[1] || (_cache[1] = () => _ctx.router.back())
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                (!_ctx.isLoadingConsultasLoja)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.totalConsultasLoja), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createVNode(_component_el_skeleton, {
                        class: "d-flex align-items-center flex-grow-1",
                        animated: "",
                        rows: 0
                      })
                    ]))
              ]),
              (!_ctx.isLoadingConsultasLoja)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    (_ctx.seriesLojaConsultas.length > 0)
                      ? (_openBlock(), _createBlock(_component_apexchart, {
                          key: 0,
                          options: _ctx.chartOptionsLojaConsultas,
                          series: _ctx.seriesLojaConsultas,
                          width: "400"
                        }, null, 8, ["options", "series"]))
                      : (_openBlock(), _createElementBlock("svg", _hoisted_18, _hoisted_20))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _createVNode(_component_el_skeleton, {
                      animated: "",
                      rows: 1
                    })
                  ]))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _createElementVNode("div", _hoisted_27, [
                (!_ctx.isLoadingMarcas)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      (_ctx.seriesMarcas.length > 0)
                        ? (_openBlock(), _createBlock(_component_apexchart, {
                            key: 0,
                            options: _ctx.chartOptionsMarcas,
                            series: _ctx.seriesMarcas,
                            width: "400"
                          }, null, 8, ["options", "series"]))
                        : (_openBlock(), _createElementBlock("svg", _hoisted_29, _hoisted_31))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      _createVNode(_component_el_skeleton, {
                        animated: "",
                        rows: 1
                      })
                    ]))
              ])
            ])
          ])
        ])
      ])
    ]),
    (!_ctx.isLoadingConsultasLoja)
      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
          (_ctx.dataTable.length > 0)
            ? (_openBlock(), _createElementBlock("table", _hoisted_34, [
                _hoisted_35,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataTable, (componente, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: index,
                      style: {"cursor":"pointer"}
                    }, [
                      _createElementVNode("td", null, _toDisplayString(componente.marcaVeiculo), 1),
                      _createElementVNode("td", null, _toDisplayString(componente.modeloVeiculo), 1),
                      _createElementVNode("td", null, _toDisplayString(componente.anoVeiculo), 1),
                      _createElementVNode("td", _hoisted_36, _toDisplayString(_ctx.moment(componente.created_at).locale("pt-br").format('DD/MM/YYYY')), 1)
                    ]))
                  }), 128))
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_37, _hoisted_39))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_40, [
          _createVNode(_component_el_skeleton, {
            animated: "",
            rows: 3
          })
        ]))
  ]))
}